// Create a new file: src/app/optional-components.ts

import { Type } from '@angular/core';
import { environment } from './environments/environment';

// Interface for feature configuration
export interface FeatureConfig {
  enabled: boolean;
  component?: Type<any>;
  path?: string;
}

// Define which features are enabled/disabled
export const FEATURES: { [key: string]: FeatureConfig } = {
  publish: {
    enabled: environment.features?.publish ?? true,
    path: 'publish'
  },
  dashboard: {
    enabled: environment.features?.dashboard ?? true,
    path: 'dashboard'
  },
  cloudflare: {
    enabled: environment.features?.dashboard ?? true,
    path: 'cloudflare'
  },
  team: {
    enabled: environment.features?.team ?? false,
    path: 'teams'
  },
  shipping: {
    enabled: environment.features?.shipping ?? false,
    path: 'shipping'
  },
  storePickup: {
    enabled: environment.features?.storePickup ?? false,
    path: 'shipping/pickup'
  },
  //   kanban: {
//     enabled: environment.features?.kanban ?? true,
//     path: 'kanban'
//   },
//   payment: {
//     enabled: environment.features?.payment ?? true,
//     path: 'payment'
//   },
//   contentEditor: {
//     enabled: environment.features?.contentEditor ?? true,
//     path: 'content'
//   }
  // Add more features as needed
};

// Lazy loading helper function
export const loadComponent = async (featureName: string): Promise<Type<any> | null> => {
    const feature = FEATURES[featureName];
    
    if (!feature || !feature.enabled) {
      return null;
    }
    
    if (feature.component) {
      return feature.component;
    }
    
    try {
    // Dynamic import based on feature path
    switch(featureName) {
      case 'publish':
        const publishModule = await import('./app/publish/publish.component');
        feature.component = publishModule.PublishComponent;
        break;

        case 'dashboard':
          const dashboardModule = await import('./app/webddn/dashboard/dashboard.component');
          feature.component = dashboardModule.DashboardComponent;
          break;
    //   case 'kanban':
    //     const kanbanModule = await import('./kanban/kanban.component');
    //     feature.component = kanbanModule.KanbanComponent;
    //     break;
    //   case 'payment':
    //     const paymentModule = await import('./payment/payment.component');
    //     feature.component = paymentModule.PaymentComponent;
    //     break;
    //   case 'contentEditor':
    //     const contentEditorModule = await import('./content/content-editor/content-editor.component');
    //     feature.component = contentEditorModule.ContentEditorComponent;
    //     break;
      default:
        return null;
    }
    
    return feature.component;
  } catch (error) {
    console.error(`Failed to load component for feature: ${featureName}`, error);
    return null;
  }
};